import { Component } from "react";
import Layout from "../../componentes/Comunes/Layout/Layout";
import PageHeading from "../../componentes/Comunes/PageHeading";
import { Parametros } from "../../componentes/InformacionCrediticia/Descargables/Parametros";

export class ArchivoDescargable extends Component {
    render() {
        return (
            <Layout>
                <PageHeading title="Archivos Comportamiento de Pago" />
                <Parametros />
            </Layout>

        )
    }
}